import { render, staticRenderFns } from "./SelectionOptionIcon.vue?vue&type=template&id=2c0b91c8"
import script from "./SelectionOptionIcon.vue?vue&type=script&lang=js"
export * from "./SelectionOptionIcon.vue?vue&type=script&lang=js"
import style0 from "./SelectionOptionIcon.vue?vue&type=style&index=0&id=2c0b91c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports